export const defaultTestCaseFilters = {
  priority: "All",
  status: "All",
  module: [],
  owner: [],
  reviewer: [],
  approvedBy: [],
  technologyLayer: "All",
  geographies: [],
  languages: [],
  cloudDevice: [],
  platforms: [],
  subPlatforms: [],
};

